const MainContainer = (props) => {
    return (
        <div {...props}>
            {props.children}
        </div>
    )
}

export default MainContainer